(()=>{
  const route=document.querySelector('[data-ckb-canonical-route]');
  if(!route)return;
  const params=new URL(window.location.href).searchParams;
  const prefix=route.dataset.chapterPrefix||'';
  const fallback=route.dataset.defaultFocus||'';
  const requested=(params.get('focus')||window.location.hash.slice(1)||'').trim();
  const candidate=requested?(requested.includes('--')?requested:`${prefix}--${requested}`):fallback;
  const index=window.CKB_MASTER_HANDBOOK_INDEX||[];
  const anchors=new Set(index.map(item=>item.anchor));
  const focus=anchors.has(candidate)?candidate:fallback;
  const destination=new URL('/pages/chameleon-knowledge-base',window.location.origin);
  for(const key of ['preview_theme_id','ckb_return']){
    const value=params.get(key);
    if(value)destination.searchParams.set(key,value);
  }
  destination.searchParams.set('focus',focus);
  const query=params.get('ckb_query')||params.get('search')||index.find(item=>item.anchor===focus)?.title||(requested?requested.replace(/[-_]+/g,' '):'');
  if(query)destination.searchParams.set('ckb_query',query);
  destination.hash='ckb-master-handbook';
  window.location.replace(destination.toString());
})();
